/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { T as Toolbar, d as defineCustomElement$1 } from './p-Dt8zaCLQ.js';

const IonToolbar = Toolbar;
const defineCustomElement = defineCustomElement$1;

export { IonToolbar, defineCustomElement };
